<div class="flex flex-col items-start">
  <div class="typo-h3-semibold text-text-primary">{{ participantsString }}</div>
  @if (chatHeaderInfo.subject) {
    <div class="m typo-h4-medium text-text-primary">{{ chatHeaderInfo.subject }}</div>
  }
  <div class="mt-2 flex w-full items-center gap-4">
    <div class="rounded-lg bg-background-tag px-2">
      <span class="typo-h5-semibold text-primary-blue">
        {{ (chatHeaderInfo.linkedPatientName ? 'collab_type_clinical_collab' : 'collab_type_team_collab') | translate }}
      </span>
    </div>
    @if (chatHeaderInfo.linkedPatientName) {
      <a
        class="flex items-center gap-1"
        target="_blank"
        (click)="onNavigateToPatientChart($event)"
        [routerLink]="['/', routes.site, chatHeaderInfo.siteId, routes.patients, chatHeaderInfo.linkedPatient?.id, routes.charting]"
      >
        <span class="typo-h5-book">{{ chatHeaderInfo.linkedPatientName }}</span>
        <svg-icon key="px-24-chart" size="sm" class="text-primary-blue-pressed"></svg-icon>
      </a>
    }
  </div>
</div>
<lib-collaboration-participants [participants]="chatHeaderInfo.allParticipants" (openAddParticipantsModal)="onOpenClick()" />
